import React from "react";
import { useTable, useGlobalFilter } from "react-table";
import { GlobalFilter } from "./GlobalFilter";

interface columnsInterface {
  Header: string;
  accessor: string;
}

export interface TableProps extends React.TableHTMLAttributes<HTMLElement> {
  className?: string;
  data: object[];
  columns: columnsInterface[];
  summation?: boolean;
  numuric?: string;
  filter?: boolean;
}

export const Table: React.FC<TableProps> = ({
  className,
  data,
  columns,
  summation,
  numuric,
  filter,
}) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    setGlobalFilter,
    state,
  }: any = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter
  );

  const { globalFilter } = state;

  return (
    <>
      <div className="relative max-h-[calc(100vh-7rem)] overflow-x-auto">
        {filter && (
          <GlobalFilter filter={globalFilter} setFilter={setGlobalFilter} />
        )}
        <table
          className={`${className} w-full text-left text-sm text-gray-500`}
          {...getTableProps()}
        >
          <thead className="bg-gray-50 text-xs uppercase text-gray-700">
            {headerGroups.map((headerGroup: any, index: number) => (
              <tr key={index} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column: any, index: number) => (
                  <th
                    key={index}
                    {...column.getHeaderProps()}
                    className="whitespace-nowrap px-6 py-3"
                  >
                    {column.render("Header")}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {rows.map((row: any, index: number) => {
              prepareRow(row);
              return (
                <tr
                  key={index}
                  {...row.getRowProps()}
                  className="border-b bg-white"
                >
                  {row.cells.map((cell: any, index: number) => {
                    return (
                      <td
                        key={index}
                        {...cell.getCellProps()}
                        className="px-6 py-4 whitespace-nowrap"
                      >
                        {cell.render("Cell")}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {summation && numuric && (
        <div className="flex bg-slate-100 p-5 justify-between items-center my-3">
          <p>Total</p>
          <div className="flex gap-6">
            {["EGY", "USD", "RMB", "EUR"].map((el: any) => {
              return (
                <p
                  className="flex gap-1 items-baseline bg-slate-300 p-2 rounded"
                  key={el}
                >
                  <span className="text-xl font-medium">
                    {rows.reduce(
                      (prev: number, curr: any) =>
                        prev +
                        (curr.values["currency"] === el
                          ? curr.values[numuric]
                          : 0),
                      0
                    )}
                  </span>
                  <span className="text-sm">{el}</span>
                </p>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
};
